import { useLocation } from 'react-router-dom';

/** Reads L&D entry params from the learning URL query string. */
export function useLearningQuery() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  return {
    packageId: params.get('package_id'),
    userId: params.get('user_id'),
    surveyId: params.get('survey_id'),
    inviteId: params.get('invite_id'),
    locationId: params.get('location_id'),
    guidanceVersion: params.get('guidance_version'),
    search,
  };
}
